/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC, useEffect} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import ConfirmEmail from "../modules/auth/components/ConfirmMail";
import ResetPasswordKeyCheck from "../modules/auth/components/ResetPasswordKeyCheck";
import { useSelector } from 'react-redux'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  const userStore = useSelector((state:any) => state?.userProfileData  )
  useEffect(() => {
    console.log('currentUser : ', currentUser)
  }, [currentUser])
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {/*<Route path='reset-password/:reset_key' element={<ResetPassword />} />*/}
          <Route path='reset-password' element={<ResetPasswordKeyCheck />} />
          <Route path='reset-password/:rpKey' element={<ResetPasswordKeyCheck />} />
          <Route path='confirm-email-change/:code' element={<ConfirmEmail />} />
          {(currentUser || userStore) ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/home' />} />
            </>
          ) : (
            <>
              <Route path='/*' element={<AuthPage />} />
              <Route index element={<Navigate to='/login' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
